import { render } from "./UserDetailsCard.vue?vue&type=template&id=23504f50&scoped=true"
import script from "./UserDetailsCard.vue?vue&type=script&lang=js"
export * from "./UserDetailsCard.vue?vue&type=script&lang=js"

import "./UserDetailsCard.vue?vue&type=style&index=0&id=23504f50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23504f50"]])

export default __exports__